import * as React from "react";
import { Routes, Route } from "react-router-dom";
import About from "./About";
import "./App.css";
import Navbar from "./Components/Navbar";
import Findjob from "./Findjob";
import Home from "./Home";
import JobPost from "./JobPost";
import Contact from "./Contact";

export default function App() {
  return (
    <div className="flex flex-col w-full">
      <Navbar />
      <footer className="text-white text-center mb-1 fixed bottom-0 w-full h-6 bg-blue-900">
      © All rights reserved | Made by PCAS
      </footer>
      <div className="mb-20 md:mb-0">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/jobpost" element={<JobPost />} />
          <Route path="/about" element={<About />} />
          <Route path="/findjob" element={<Findjob />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </div>
  );
}
